"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Embed = void 0;
var react_1 = __importStar(require("react"));
var styled_1 = require("../styled");
var mixins_1 = require("../../../themes/mixins");
// import DisplayCoachmark from '../utils/DisplayCoachmark'
var embadableUrl_1 = require("../utils/embadableUrl");
var _EXPORTS_1 = require("../../../utils/_EXPORTS");
var styled_components_1 = require("styled-components");
var filters_1 = require("../utils/filters");
var Embed = function (_a) {
    var isBlock = _a.isBlock, readOnly = _a.readOnly, value = _a.value, isValidURL = _a.isValidURL, onChange = _a.onChange;
    var _b = (0, react_1.useState)(value && (0, filters_1.extractHeight)(value)), height = _b[0], setHeight = _b[1];
    var theme = (0, styled_components_1.useTheme)();
    // const { user } = theme?.useGetQueryData('userData') || {};
    // const screenWidth = useScreenWidth()
    var embedRef = (0, react_1.useRef)(null);
    var handleOnLoad = function () {
        var _a;
        setHeight((_a = (0, filters_1.extractHeight)(value)) === null || _a === void 0 ? void 0 : _a.replace(/[^\d.]/g, '')); // strip any special charachter like curly quotes, set height as a number
    };
    (0, react_1.useEffect)(function () {
        handleOnLoad();
    }, [onChange]);
    return (react_1.default.createElement(styled_1.StyledEmbedPreview, { readOnly: readOnly, attrHeight: Number(height) },
        react_1.default.createElement(styled_1.StyledEmbedWrapper, null,
            react_1.default.createElement(styled_1.StyledEmbed // styled iFrame element
            , { src: (0, embadableUrl_1.embadableURL)(value, isValidURL), ref: isBlock && embedRef, onLoad: handleOnLoad, width: "100%", height: "100%", allowFullScreen: true, mozallowfullscreen: true, webkitallowfullscreen: true, style: { border: 0 } }))));
};
exports.Embed = Embed;
